<template>
  <a-cascader
    v-model="typeArr"
    :options="typeList"
    :load-data="loadData"
    :placeholder="placeholder || '请选择'"
    change-on-select
    @change="onChange"
  />
</template>
<script>
export default {
  props: ['value', 'category', 'placeholder'],
  data() {
    return {
      typeArr: [],
      typeList: [],
    }
  },
  watch: {
    value(val) {
      if (!val) this.typeArr = []
    },
  },
  mounted() {
    this.getTypeList()
  },
  methods: {
    onChange(val) {
      this.$emit('setVal', val)
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        this.getTypeList(targetOption.id, targetOption) || []
      }, 0);
    },
    getTypeList(parentId = 0, record) {
      // /nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit
      // this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId?category=${this.category}&parentId=${parentId}`).then(res => {
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      this.$http.get(`/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=${this.category}&parentId=${parentId}&deptId=${deptId}`)
        .then(res => {
          let { success, data = [] } = res;
          if (success) {
            data && data.map(el => {
              el.value = el.id
              el.label = el.name
              el.isLeaf = !el.hasChildren
              return el
            })
            if (record) {
              if (data.length) {
                record.children = data
              } else {
                record.isLeaf = true
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data
            }
            // this.typeList = data
            // return data
          } else {
            this.typeList = []
          }
        })
    },
  }
}
</script>